<template>
  <el-form :model="info" :rules="rules" ref="form" class="m-2" label-width="100px">
    <el-form-item label="图片" prop="shop_img">
      <image-uploader v-model="info.shop_img"></image-uploader>
    </el-form-item>
    <el-form-item label="俱乐部名" prop="shop_name">
      <el-input v-model="info.shop_name" placeholder="请输入群名"></el-input>
    </el-form-item>
    <el-form-item label="简介" prop="shop_intro">
      <el-input v-model="info.shop_intro" placeholder="一句话介绍你的群（最长14个字符）"></el-input>
    </el-form-item>
    <el-form-item label="描述" prop="shop_description">
      <wang-editor v-model="info.shop_description" />
    </el-form-item>
<!--    <el-form-item label="视频">-->
<!--      <video-uploader v-model="info.shop_video"></video-uploader>-->
<!--    </el-form-item>-->
    <el-form-item label="城市">
      <city-selector v-model="info.city_id"></city-selector>
    </el-form-item>
    <el-form-item label="类型" prop="shop_type">
      <el-select v-model="info.shop_type" disabled>
        <el-option :value="7" label="俱乐部"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="标签" prop="tags">
      <el-tag v-for="(tag, index) in info.tags" :key="tag"
        closable
        @close="removeTag(index)"
        class="form-item-tag"
      >{{tag}}</el-tag>
      <!-- <el-input class="input-new-tag"
        size="mini"
        v-model="newTagName"
        @keyup.enter.native="handleNewTagConfirm"
        @blur="handleNewTagConfirm"
        placeholder="新标签"
      >
      </el-input> -->
    </el-form-item>
    <el-form-item label="显示文章" prop="display_article">
      <el-switch v-model="info.display_article" disabled></el-switch>
    </el-form-item>
    <el-form-item label="状态" prop="shop_status">
      <el-radio-group v-model="info.shop_status">
        <el-radio :label="1">审核</el-radio>
        <el-radio :label="2">上线</el-radio>
        <el-radio :label="3">下线</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button @click="()=>$router.back()">返回</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import ImageUploader from '@/components/ImageUploader'
import WangEditor from '@/components/WangEditor'
import VideoUploader from '@/components/VideoUploader'
import CitySelector from '@/components/CitySelector'
import {getShopInfo, updateAddClubInfo} from '@/api/shop'

export default {
  name: 'GroupEdit',
  components: {
    ImageUploader,
    WangEditor,
    VideoUploader,
    CitySelector
  },
  computed: {
    merchantId () {
      return this.$store.state.merchantInfo.id
    }
  },
  data () {
    const rules = {
      shop_name: [
        { required: true, message: '请输入群名', trigger: 'blur' },
        { max: 30, message: '群名不能超过30个字符', trigger: 'blur' }
      ],
      shop_img: [
        { type: 'array', required: true, message: '请上传图片', trigger: 'blur' }
      ],
      shop_intro: [
        { max: 30, message: '不能超过30个字符', trigger: 'blur' }
      ],
      shop_description: [
        { required: true, message: '请填写描述', trigger: 'blur' }
      ]
    }
    return {
      rules,
      newTagName: '',
      info: {
        shop_name: '',
        shop_img: [],
        shop_intro: '',
        shop_description: '',
        tags: [],
        shop_video: '',
        shop_status: 2
      }
    }
  },
  created () {
    if (this.$route.params.groupId) {
      this.getShopInfo()
    }
  },
  methods: {
    handleNewTagConfirm () {
      if (!this.newTagName.trim().length) {
        return
      }
      this.info.tags.push(this.newTagName)
      this.newTagName = ''
    },
    async getShopInfo () {
      const { img, name, intro_desc, status, city, description, type, tags } = await getShopInfo(this.$route.params.groupId)
      const imgs = img ? [img] : []
      this.info = {
        shop_id: this.$route.params.groupId,
        shop_img: imgs,
        shop_name: name,
        shop_intro: intro_desc,
        shop_status: status,
        shop_description: description,
        shop_type: type,
        city_id: city.id,
        tags
      }
    },
    removeTag (index) {
      this.info.tags.splice(index, 1)
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.$message.error('请检查填写项')
          return
        }
        const info = {
          ...this.info,
          merchant_id: this.merchantId,
          shop_img: this.info.shop_img.pop()
        }
//        if (!this.$route.params.groupId) {
//          updateAddClubInfo(info).then((res) => {
//            this.$message.success('保存成功')
//            this.$router.back()
//          })
//          return
//
        updateAddClubInfo(info)
          .then((res) => {
            this.$message.success('保存成功')
            this.$router.back()
          })
      })
    }
  }
}
</script>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.input-new-tag {
  max-width: 60px;
}
</style>



// WEBPACK FOOTER //
// group-edit.vue?5fa4d480